import http from "@/utils/request";

const b2b = {
  pageQuery: (data) =>
    http.sendRequest({
      METHOD_NAME: "toBStockout.pageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  create: (data) =>
    http.sendRequest({
      METHOD_NAME: "toBStockout.create",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  update: (data) =>
    http.sendRequest({
      METHOD_NAME: "toBStockout.update",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  load: (data) =>
    http.sendRequest({
      METHOD_NAME: "toBStockout.load",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  cancel: (data) =>
    http.sendRequest({
      METHOD_NAME: "toBStockout.cancel",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  ship: (data) =>
    http.sendRequest({
      METHOD_NAME: "toBStockout.ship",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  sendWms: (data) =>
    http.sendRequest({
      METHOD_NAME: "toBStockout.sendWms",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

export default b2b;
